module.exports = __webpack_public_path__ + "static/media/ADDVA_KIDS.d88c7cde.svg";